module.exports = __webpack_public_path__ + "static/media/RoomService_Lunch_Summary_1.9f320b84.png";